<template>
    <div class="splash-screen">
        <div class="container">
            <div class="logo">
                <img :src="brandLogo" alt="logo" />
            </div>
            <h1>{{ $t('m.loginTitle') }}</h1>
        </div>
    </div>
</template>
<script>
export default {
    name: "SplashScreen",
    data() {
        return {
            brandLogo: this.$store.getters['appConfig/brand_logo'],
        }
    },
    mounted() {
        // 禁止上下左右滚动
        document.body.style.overflow = 'hidden';
        // 阻止触摸事件的默认行为
        document.addEventListener('touchmove', this.preventScroll, { passive: false });
    },
    beforeDestroy() {
        // 恢复
        document.body.style.overflow = '';
        // 移除触摸事件监听器
        document.removeEventListener('touchmove', this.preventScroll);
    },
    methods: {
        preventScroll(event) {
            event.preventDefault();
        }
    }
}
</script>

<style lang="scss">
    .splash-screen {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: #fff;
        z-index: 9999;

        .container {
            display: flex;
            flex-direction: column;
            align-items: center;
            position: absolute;
            top: 45%;
            left: 50%;
            transform: translate(-50%, -50%);
        }

        .logo {
            height: 71px;
            width: 145px;

            img {
                height: 100%;
                width: 100%;
                object-fit: contain;
                object-position: center bottom;
            }
        }

        h1 {
            margin: 0;
            font-family: SF Pro Text;
            font-size: 26px;
            font-weight: 700;
            line-height: 31.2px;
            margin-top: 25px;
            width: 343px;
        }
    }
</style>
